import { Device } from '@capacitor/device';
import { Catalog } from '@vi-succ/products-domain';
import { countryToSalesOrg } from './salesorg-country';

export const findCatalogPreselection = async (catalogs: Catalog[]) => {
  const tag = await Device.getLanguageTag();
  const tagValue = tag.value;
  const fallback: Catalog = {
    salesOrg: '0500',
    language: 'de',
  };
  return (
    catalogs.find(
      (catalog) =>
        catalog.salesOrg === countryToSalesOrg(tagValue.substring(3)) && catalog.language === tagValue.substring(0, 2)
    ) ??
    catalogs[0] ??
    fallback
  );
};
